// ค่า default ของช่องรอบใน byType (batch response ของ /applicants/me/enrollment-offers)
// ระหว่าง loading หรือ type ที่ไม่มีข้อมูล — freeze กัน component ไป mutate ตัวแชร์
export const EMPTY_ROUND = Object.freeze({ offers: [], replies: [], offerCount: 0 });
